function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.8079 7.70673C14.0643 7.83707 14.0643 8.16293 13.8079 8.29327L4.57717 12.9856C4.39033 13.0806 4.16945 12.6861 4.06335 12.3641C4.00421 12.1847 4.10674 12.0101 4.27552 11.9252L11.1894 8.44665C11.5564 8.26198 11.5564 7.738 11.1894 7.55334L4.27552 4.0748C4.10674 3.98989 4.00421 3.81533 4.06335 3.63589C4.16945 3.31394 4.39033 2.9194 4.57717 3.01438L13.8079 7.70673Z",
  fill: "currentColor"
});
const SvgMore = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more.5bebae87.svg";
export { ForwardRef as ReactComponent };